import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StyledSharedAsset = styled(SharedAsset)({
  maxWidth: '100%'
});

const EditorOption = ({
  title,
  imageUrl,
  buttonText,
  ButtonProps,
  children
}) => (
  <Grid
    gap={4}
    container
    direction="column"
    justifyContent="flex-end"
    sx={{
      height: '100%',
      maxWidth: 260,
      textAlign: 'center'
    }}
  >
    <Grid item>
      <Title variant="smallBold">
        {title}
      </Title>
    </Grid>
    <Grid item>
      {imageUrl && <StyledSharedAsset src={imageUrl} />}
      {children}
    </Grid>
    <Grid item>
      <Button
        {...ButtonProps}
        fullWidth
      >
        {buttonText}
      </Button>
    </Grid>
  </Grid>
);

EditorOption.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  ButtonProps: PropTypes.shape({
    className: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string
  }).isRequired,
  children: PropTypes.node
};

export default EditorOption;
